export default __webpack_public_path__ + "img/b9907f2382b4007cd013d82a40d7914f.mp4";